<div [ngClass]="{
  'border-green': isActive,
  }"
     class="relative rounded-xl p-4 border border-gray-200 h-full max-h-[800px] max-w-md mx-auto">
  <div class="flex flex-col justify-start items-center h-full gap-2 pt-4">

    <div class="flex flex-col w-full h-full justify-start items-center gap-3">
      <div class="flex flex-col w-full justify-center items-center gap-1">
        <div [class.invisible]="product.contactOnly || productPrice?.unitAmount == 0"
             class="text-[18px] text-gray-500">{{ isRecurring() ? "Abo-Modell" : "Einmalig" }}
        </div>
        <div
          class="text-xl font-semibold">{{ name }} {{ isSpecial ? "(Custom)" : "" }}
        </div>
      </div>

      @if (product.contactOnly) {
        <!-- Kontakt-Pläne (Enterprise) haben weder Credit-Menge noch Preis. Die unsichtbaren
             Platzhalter spannen exakt den Platz auf, den in den anderen Karten Credits-Zahl und
             Preis einnehmen (inkl. gap-6 dazwischen), damit die Feature-Liste auf gleicher Höhe
             startet. Der eigentliche Text liegt darüber und ist darin vertikal zentriert. -->
        <div class="relative flex flex-col w-full justify-center items-center gap-6">
          <div aria-hidden="true" class="invisible flex flex-col w-full justify-center items-center">
            <span class="font-extrabold text-green text-[48px]">0</span>
            <span class="text-gray-500 text-base font-light">Prüfungen</span>
          </div>
          <div aria-hidden="true" class="invisible flex flex-col w-full justify-center items-center">
            <span class="font-extrabold text-gray text-[36px]">0 €</span>
            <span class="text-gray-500 text-base font-light">pro Monat</span>
          </div>
          <div class="absolute inset-0 flex flex-col justify-center items-center">
            <span class="font-extrabold text-gray text-[36px]">{{ priceHeadline }}</span>
            @if (product.priceNote) {
              <span class="text-gray-500 text-base font-light">{{ product.priceNote }}</span>
            }
          </div>
        </div>
      } @else {
        <div [class.invisible]="!product.showCreditsHeadline"
             class="flex flex-col w-full justify-center items-center">
          <span
            class="font-extrabold text-green text-[48px]">{{ product.showCreditsHeadline ? headlineValue : 0 }}</span>
          @if (isRecurring() || !product.showCreditsHeadline) {
            <span class="text-gray-500 text-base font-light">
          {{ headlineLabel }}
        </span>
          }
        </div>

        @if (productPrice?.unitAmount! > 0) {
          <div class="flex flex-col w-full justify-center items-center">
          <span
            class="font-extrabold text-gray text-[36px]">{{ (isRecurring() ? productPrice!.recurring?.interval == 'month' ? $safeNavigationMigration(productPrice?.unitAmount)! / 100 : $safeNavigationMigration(productPrice?.unitAmount)! / 100 / 12 : $safeNavigationMigration(productPrice?.unitAmount)! / 100) | number }}
            € </span>
            @if (isRecurring()) {
              <span class="text-gray-500 text-base font-light">
            pro Monat
          </span>
            }
          </div>
        }

        @if (priceHeadline) {
          <div class="flex flex-col w-full justify-center items-center">
            <span class="font-extrabold text-gray text-[36px]">{{ priceHeadline }}</span>
            @if (product.priceNote) {
              <span class="text-gray-500 text-base font-light">{{ product.priceNote }}</span>
            }
          </div>
        }
      }

      <app-shop-feature-list [active]="!isAddOn && isActive" [features]="product.features ?? []"
                             class="flex w-full"></app-shop-feature-list>
    </div>


    <bic-button
      [buttonType]="isAddOn && !isActive ? 'white' : isAddOn && isActive ? 'primary' : isActive ? 'primary' : 'white'"
      (onClick)="onCta()"
      [disabled]="!product.contactOnly && (isTestphaseAndHasActivePrice || isActive || (isAddOn && isActive))"
      class="w-full text-center">
      {{ ctaLabel }}
    </bic-button>

  </div>

  <div class="flex flex-row w-full justify-end items-center gap-2 absolute top-0 right-0 pt-2 pr-2">
    @if (product.badgeLabel) {
      <bic-badge type="warning">{{ product.badgeLabel }}</bic-badge>
    }
    @if (price && !productPrice?.livemode) {
      <bic-badge type="warning">TEST MODE</bic-badge>
    }
  </div>
</div>
